// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__vKCNJ","checkbox-label":"Checkbox_checkbox-label__pGER-","checkboxActive":"Checkbox_checkboxActive__R6Q6r","tooltip":"Checkbox_tooltip__QJNsv"};